// Core-owned usage defaults only. Product usage descriptions live in their manifests.
const COLOR_USAGE_DEFAULT_CONFIG = {
  "catalogs": [
    {
      "katalog_key": "standard",
      "label": "Standard",
      "active_flag": true,
      "sort_order": 10
    },
    {
      "katalog_key": "ral",
      "label": "RAL Classic",
      "active_flag": true,
      "sort_order": 20
    },
    {
      "katalog_key": "ncs",
      "label": "NCS",
      "active_flag": true,
      "sort_order": 30
    },
    {
      "katalog_key": "decor",
      "label": "Dekor",
      "active_flag": true,
      "sort_order": 40
    },
    {
      "katalog_key": "texturen",
      "label": "Texturen",
      "active_flag": true,
      "sort_order": 50
    },
    {
      "katalog_key": "texturen_boden",
      "label": "Boden",
      "active_flag": true,
      "sort_order": 60
    },
    {
      "katalog_key": "texturen_wand",
      "label": "Wand",
      "active_flag": true,
      "sort_order": 70
    },
    {
      "katalog_key": "texturen_decke",
      "label": "Decke",
      "active_flag": true,
      "sort_order": 80
    },
    {
      "katalog_key": "texturen_doppelboden",
      "label": "Doppelboden",
      "active_flag": true,
      "sort_order": 90
    },
    {
      "katalog_key": "texturen_doppeldecke",
      "label": "Doppeldecke",
      "active_flag": true,
      "sort_order": 100
    }
  ],
  "usages": [
    {
      "active_flag": true,
      "usage_key": "sketchWallColorPicker",
      "system_label": "Parametrische Wand",
      "label": "Wand (Farbe)",
      "sort_order": 10
    },
    {
      "active_flag": true,
      "usage_key": "sketchWallFurringColorPicker",
      "system_label": "Parametrische Wand",
      "label": "Vormauerung",
      "sort_order": 20
    },
    {
      "active_flag": true,
      "usage_key": "levelFloorTexturePicker",
      "system_label": "Ebenen",
      "label": "Boden",
      "sort_order": 10
    },
    {
      "active_flag": true,
      "usage_key": "levelDoubleFloorTexturePicker",
      "system_label": "Ebenen",
      "label": "Doppelboden",
      "sort_order": 20
    },
    {
      "active_flag": true,
      "usage_key": "levelCeilingTexturePicker",
      "system_label": "Ebenen",
      "label": "Decke",
      "sort_order": 30
    },
    {
      "active_flag": true,
      "usage_key": "levelDoubleCeilingTexturePicker",
      "system_label": "Ebenen",
      "label": "Doppeldecke",
      "sort_order": 40
    }
  ],
  "usageCatalogs": [
    {
      "usageKey": "sketchWallColorPicker",
      "katalogKey": "ral"
    },
    {
      "usageKey": "sketchWallColorPicker",
      "katalogKey": "ncs"
    },
    {
      "usageKey": "sketchWallFurringColorPicker",
      "katalogKey": "ral"
    },
    {
      "usageKey": "sketchWallFurringColorPicker",
      "katalogKey": "ncs"
    },
    {
      "usageKey": "sketchWallFurringColorPicker",
      "katalogKey": "decor"
    },
    {
      "usageKey": "sketchWallFurringColorPicker",
      "katalogKey": "texturen"
    },
    {
      "usageKey": "levelFloorTexturePicker",
      "katalogKey": "texturen_boden"
    },
    {
      "usageKey": "levelDoubleFloorTexturePicker",
      "katalogKey": "texturen_doppelboden"
    },
    {
      "usageKey": "levelCeilingTexturePicker",
      "katalogKey": "texturen_decke"
    },
    {
      "usageKey": "levelDoubleCeilingTexturePicker",
      "katalogKey": "texturen_doppeldecke"
    }
  ]
};
export { COLOR_USAGE_DEFAULT_CONFIG };
